module.exports = __webpack_public_path__ + "resources/img/map_nhn_playhub.574eea0ec1579052ce214a832908bf20.jpg";